import {Component, OnInit} from '@angular/core';
import {TruckLoad} from '../../../models/loads/truck-load.model';
import {LoadsService} from '../../../services/loads/loads.service';
import {Router} from "@angular/router";
import * as moment from "moment/moment";
import {DynamicListEntity} from '../../../models/list/dynamic-list-entity';
import {ListService} from '../../../services/list/list.service';
import * as XLSX from 'xlsx';
import {UserService} from '../../../services/user/user.service';

@Component({
    selector: 'app-truck-load-list',
    templateUrl: './truck-load-list.component.html',
    styleUrls: ['./truck-load-list.component.scss']
})
export class TruckLoadListComponent implements OnInit {

    entities: TruckLoad[] = [];
    searchDateStatus = ['Teslimat Tarihi', 'Oluşturma Tarihi', 'Sefer Açılış Tarihi', 'Sefer Faaliyet Tarihi'];
    dateStatus = 'Oluşturma Tarihi';
    startDate: Date;
    endDate: Date;
    deliveryStatus = [{name: 'Kabul Edildi', code: 'CT-01'}, {name: 'İptal Edildi', code: 'CT-01'},{name: 'Teslim Edildi', code: 'CT-01'},{name: 'Yolda', code: 'CT-01'},{name: 'Hepsi', code: null}];
    status = 'Hepsi';
    dynamicListEntity: DynamicListEntity;
    isLoading: boolean = false;
    filters = {
        creationDateStart: {
            prefix: 'createDate/DT/GT',
            value: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        },
        creationDateEnd: {
            prefix: 'createDate/DT/LT',
            value: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
        },
        orderNo: {
            prefix: 'orderNo/LIKE',
            value: '',
        },
        status: {
            prefix: 'status.code',
            value: '',
        },
        customer: {
            prefix: 'customer',
            value: this.userService.getCompany().id,
        },
        getParams: () => {
            let params = {};
            Object.keys(this.filters).forEach(k => {
                if(typeof this.filters[k] == "function") return;
                // @ts-ignore
                if(this.filters[k].value) {
                    // @ts-ignore
                    let value = this.filters[k].value;
                    if(typeof value  == 'object') {
                        value = value instanceof Date ? value.toISOString().slice(0, -1): (value.code || value.id)
                    }

                    let isStart = false;
                    // date format fix
                    if(this.filters[k].prefix.includes('/DT/')) {
                        let d = new Date(value);
                        d.setDate(d.getDate() +1);
                        if(this.filters[k].prefix.includes('/GT') ) {
                            isStart = true;
                            value = d.toISOString().split('T')[0] + 'T00:00:00.000'
                        }
                        if(this.filters[k].prefix.includes('/LT') ) {
                            value = d.toISOString().split('T')[0] + 'T23:59:59.000'
                        }
                    }
                    Object.assign(params, {[this.filters[k].prefix.includes('/DT/') ? this.getDatePrefix(isStart) : this.filters[k].prefix]: value});
                }
            })
            return params;
        }
    }
    distributionReferenceNo = null;

    constructor(private listService: ListService, private loadsService: LoadsService, private router: Router, private userService: UserService) {
    }


    getDatePrefix(isStart) {
        if (isStart) {
          return this.dateStatus === 'Sefer Açılış Tarihi' ? 'voyageStartCreateDate' : this.dateStatus === 'Sefer Faaliyet Tarihi' ? 'operationStartDate' : this.dateStatus === 'Teslimat Tarihi' ? 'deliveryDate/DT/GT' : 'createDate/DT/GT';
        }else {
            return this.dateStatus === 'Sefer Açılış Tarihi' ? 'voyageEndCreateDate' : this.dateStatus === 'Sefer Faaliyet Tarihi' ? 'operationEndDate' : this.dateStatus === 'Teslimat Tarihi' ? 'deliveryDate/DT/LT'  : 'createDate/DT/LT';
        }
    }

    ngOnInit(): void {
        const date = new Date();
        this.startDate = new Date(date.getFullYear(), date.getMonth(), 1);
        this.endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    }

    async search() {
        try {
            this.isLoading = true;
            let par = this.filters.getParams();
            this.dynamicListEntity = await this.listService.search("getDomesticDistributionOrderPackList", par).toPromise();
            this.isLoading = false;
        } catch {
            this.isLoading = false;
        }
    }


    navigateloadDetail(id) {
        this.router.navigate([`/loads/truckLoad/${id}`])
    }

    async exportToExcel() {
        if(!this.dynamicListEntity) return;
        var rows = [];
        var header = [];
        const colSizes = [];
        const rowSizes = [];

        for (let column of this.dynamicListEntity.dynamicListFieldDefs) {
            header.push(column["header"]);
            colSizes.push({ wch: column["width"] / 7 });//7 ekrandakine yakın olsun diye oranti normalde width 100 150 geliyor excelin olcu birimi farkli
        }
        rows.push(header);

        let filteredOrFull: any[];
        filteredOrFull = this.dynamicListEntity.datas;



        for (let data of filteredOrFull) {
            rowSizes.push({ hpt: 25 });
            var row = [];
            for (let column of this.dynamicListEntity.dynamicListFieldDefs) {//UFUK stunlarda gozukmeyen id posid index vs alanlari aktarmıyoruz o yuzden stun bazlı donuyoruz
                if (column.type == "number") {
                    let number = String(data[column.id]);
                    //let number = data[column.id].replace(/\./g, '');
                    //number = number.replace(/\,/g, '.');

                    // column type number olsa da subQuery ile gelen sonuç 4.222,33 gibi olabiliyor
                    // değer 4.000,33 gibi bir rakkamsal değer olduğunu anlıyoruz.
                    if(number.indexOf(',') > -1 && number.indexOf('.') > -1) {
                        number = number.replace(/\./g, '').replace(/\,/g, '.');
                    } else {
                        // bu durumda 2.202 gibi bir rakkamsal değer olduğunu anlıyoruz.
                        number = number.replace(/\,/g, '.');
                    }

                    row.push(Number(number));
                } else if (column.type == "date") {
                    if (data[column.id] != null) {
                        try {
                            let date = moment(data[column.id], 'YYYY-MM-DD');
                            console.log('datee',date)
                            row.push(date.format('DD.MM.YYYY'));
                        } catch (error) {
                            row.push(data[column.id]);
                        }
                    } else {
                        row.push(null);
                    }
                } else {
                    row.push(data[column.id]);
                }
            }
            rows.push(row);
            row = [];
        }


        var row = [];
        var emptyRow = [];

        for (let column of this.dynamicListEntity.dynamicListFieldDefs) {//UFUK toplamları ekliyoruz
            emptyRow.push("");
            if (column == null || !column) {
                row.push("");
            } else {
                console.log(column)
                row.push(this.getTotal(column, false));
            }
        }

        rows.push(emptyRow);
        rows.push(row);

        const workSheet = XLSX.utils.json_to_sheet(rows, { skipHeader: true, dateNF: 'dd/MM/yyyy', cellDates: true });
        workSheet['!cols'] = colSizes;
        workSheet['!rows'] = rowSizes;
        //const workSheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(rows);
        const workBook: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, workSheet, 'Tmaxx');
        XLSX.writeFile(workBook, this.dynamicListEntity.dynamicListDef.name + ".xlsx");
    }

    getStatus(status){

        switch (status) {
            case 'CT-01':
                return  'Kabul Edildi';
            case 'CT-013':
                return  'Yükleme Başladı';
            case 'CT-014':
                return  'Yükleme Bitti';
            case 'CT-015':
                return  'Yolda';
            case 'CT-03':
                return  'İndirilme Tamamlandı';
            case 'CT-04':
                return  'Fotoğraf Eklendi';
            case 'CT-05':
                return  'Teslim Edildi';
            case 'CT-06':
                return  'İptal Edildi';
            default:
                return null;
        }
    }

    formatValue(column, value) {
        if (column?.type == "number") {
            // let number = value;
            return value;
            // const val = (number)?.toLocaleString('tr-TR', {style: 'currency',currency: 'TRY',});
            // if(val?.length == 1) return val;
            // return (number)?.toLocaleString('tr-TR', {style: 'currency',currency: 'TRY',}).substring(1)
        } else if (column.type == "date") {
            if (value != null) {
                try {
                    return moment(value.substr(0,10), 'YYYY.MM.DD').format('DD.MM.YYYY');
                } catch (error) {
                    return "";
                }
            }
        } else {
            return value;
        }
        return value;
    }


    getTotal(column, formatted = true) {
        let sum = 0;
        if (column.type == "number" && this.dynamicListEntity) {

            this.dynamicListEntity.datas.forEach( f =>  sum += Number(f[column.id]))
            if(formatted) return this.formatValue(column, sum);
            return sum;
        }
        return "";
    }

}
